import Keycloak from 'keycloak-js';

let keycloak = null;

export const initKeycloak = () => {
  return new Promise((resolve, reject) => {
    keycloak = new Keycloak({
      url: 'https://sso.loxone.com/',
      realm: 'loxone',
      clientId: 'portal',
    });

    const storedToken = localStorage.getItem('keycloak-token');
    const storedRefreshToken = localStorage.getItem('keycloak-refresh-token');

    keycloak.init({
      onLoad: 'check-sso',
      checkLoginIframe: true,
      token: storedToken,
      refreshToken: storedRefreshToken,
    }).then(async (authenticated) => {
      if (authenticated) {
        localStorage.setItem('keycloak-token', keycloak.token);
        localStorage.setItem('keycloak-refresh-token', keycloak.refreshToken);
        resolve(keycloak.token);
      } else {
        keycloak.login();
        resolve(null);
      }
    }).catch((error) => {
      console.error('Keycloak initialization failed:', error);
      reject(error);
    });
  });
};

export const logoutKeycloak = () => {
  if (keycloak) {
    keycloak.logout({ redirectUri: 'https://library.loxone.com' });
    localStorage.removeItem('keycloak-token');
    localStorage.removeItem('keycloak-refresh-token');
  }
};